import React from 'react'
import { getEmissionCoefficient } from '../../emission-coefficients/emission-coefficient-calculator'
import {
  COEFFICIENT_CHECKPOINT_YEARS,
  EmissionModel,
} from '../../emission-coefficients/emission-coefficients'
import { PurchasedEnergyType } from '../../generated/graphql'
import CoefficientsAccordion from './CoefficientsAccordion'

type Props = {
  emissionModel: EmissionModel
}

export function CarbonFootprintSideBarContent({
  emissionModel,
}: Props): React.ReactElement {
  const coefficientsByEnergyType = Object.values(PurchasedEnergyType).map(
    (energyType) => ({
      energyType,
      coefficients: [
        emissionModel.buildingYear,
        ...COEFFICIENT_CHECKPOINT_YEARS,
      ].map((year) => ({
        year,
        value: getEmissionCoefficient(energyType, year),
      })),
    }),
  )

  return (
    <CoefficientsAccordion
      coefficientsByEnergyType={coefficientsByEnergyType}
      emissionModel={emissionModel}
    />
  )
}
